// extracted by mini-css-extract-plugin
module.exports = {"container":"_f784a71","ace":"_995b5e6","textContainer":"_2f27fb6","imageContainer":"_a698ea6","title":"_0681509","logo":"_cfb0ecf"};